import { Tab, Tabs } from '@mui/material'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { getAuthState } from '@/features/auth/slice'
import { getMediaState } from '@/features/media/slice'
import { useAppSelector } from '@/redux/hooks'
import { links } from './links'

export default function Nav() {
  const { isAdmin, isProvider } = useAppSelector(getAuthState).userRights

  const platform = useAppSelector(getMediaState).isPerkins ? 'perkins' : 'cat'
  const location = useLocation()

  const currentTab =
    links.find((l) => l.to === location.pathname)?.value || false

  const NavTabs = useMemo(() => {
    return links
      .filter(({ visibleTo, platforms, ...props }) => {
        const isCurrentTab = props.value === currentTab
        const samePlatform = !platforms || platforms.includes(platform)
        const admin = !visibleTo || (isAdmin && visibleTo.includes('admin'))
        const provider =
          !visibleTo || (isProvider && visibleTo.includes('provider'))

        return isCurrentTab || (samePlatform && (admin || provider))
      })
      .map(({ visibleTo, ...props }) => <Tab key={props.value} {...props} />)
  }, [isAdmin, isProvider, platform, location])

  return (
    <Tabs
      value={currentTab}
      variant="scrollable"
      role="navigation"
      allowScrollButtonsMobile
    >
      {NavTabs}
    </Tabs>
  )
}
